(ns frontend.test.number-input.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::integer-value
 (fn [db _]
   (get db ::integer-value)))

(rf/reg-sub
 ::float-value
 (fn [db _]
   (get db ::float-value)))

(rf/reg-sub
 ::min-decimals
 (fn [db _]
   (get db ::min-decimals)))

(rf/reg-sub
 ::max-decimals
 (fn [db _]
   (get db ::max-decimals)))
